import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError, mergeMap } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { OAuthService } from 'angular-oauth2-oidc';
import { AppState } from '../../reducers';
import { authUserSelector } from '../../auth/store/auth.selectors';
import { AccountService } from '../services/account.service';
import { AuthUser } from '../../auth/models/user.model';
import { ClientNames } from '../../clients/client-names.enum';
import { environment } from '../../../environments/environment';

export const accountGuard: CanActivateFn = (
  route,
  state,
  store: Store<AppState> = inject(Store<AppState>),
  accountService: AccountService = inject(AccountService),
  oauthService: OAuthService | null = inject(OAuthService, { optional: true })
): Observable<boolean> => {
  return store.pipe(
    select(authUserSelector),
    mergeMap(user =>
      accountService.getAccountByOpenId(user?.sub).pipe(
        map(() => true),
        catchError(() => {
          if (
            environment.appName === ClientNames.console &&
            AuthUser.needsAuth0Migration(user)
          ) {
            // Before redirecting to the migration page, we clear the token
            // so that when the user returns they go through the auth flow and receive a fresh token.
            if (oauthService) {
              oauthService.logOut(true);
            }
            const returnUrl = encodeURIComponent(window.location.origin);
            location.href = `${environment.myUrl}/migration?return_url=${returnUrl}`;
            return of(false);
          }
          location.href = `${environment.myUrl}`;
          return of(false);
        })
      )
    )
  );
};
